export interface MenuType {
  key: string;
  img: string;
  label: string;
  type?: MenuActionType;
  activeImg?: string;
  to?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  dataAction?: string;
}

export enum MenuActionType {
  FOLDER = "folder",
  MODAL = "modal",
  DIVIDER = "divider",
  HYPERLINK = "hyperlink",
  VIEWFAN = "view-fan",
}
